import type {OffsetPageInfo} from '@/types';
import type {AfriexParams} from '@/types/AfriexQueryParams';

export interface AfriexProcessorTransaction {
  processorTransactionId: string;
  createdAt: string;
  status: string;
  asset: string;
  type: string;
  processor: string;
  country: string;
  amount: number;
  processorResponseMeta: {
    rfpRequestStatus: string;
  };
}

export enum AfriexPaymentProcessors {
  TRICE = 'TRICE',
}

export enum AfriexProcessorPaymentTypes {
  DEPOSIT = 'DEPOSIT',
  WITHDRAW = 'WITHDRAW',
}

export type AfriexProcessorTxParams = AfriexParams<{
  processor: AfriexPaymentProcessors;
  offset?: number;
  type?: string;
  country?: string;
  startDate?: string;
  endDate?: string;
  processorTransactionId?: string;
}>;

export interface ProcessorTxProps {
  transactions: AfriexProcessorTransaction[];
  filterCount: number;
  currentFilters: AfriexProcessorTxParams;
  filtersToApply: AfriexProcessorTxParams;
  clearFilters: () => void;
  selectAppliedFilters: (name: string, date: string | Date | undefined) => void;
  /** Returns whether the filters were applied; false when validation rejected them. */
  handleApplyFilters: () => boolean;
  selectCurrentFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
}

export type ProcessorTxListProps = {
  isLoading: boolean;
  txList: AfriexProcessorTransaction[];
  pageInfo: OffsetPageInfo;
  /**
   * Whatever `fetchTransactionList` caught. Was `typeof Error | null`, which
   * is the `Error` *constructor* rather than an error instance, and only
   * type-checked because the hook stored the caught value through an `any`.
   */
  error: unknown;
  currentFilters: AfriexProcessorTxParams;
  filtersToApply: AfriexProcessorTxParams;
  filterCount: number;
  /**
   * Async: the hook awaits the transaction request. Declared honestly so
   * callers can sequence on it, matching `handleOffsetChange` below.
   */
  fetchTransactionList: (params: AfriexProcessorTxParams) => Promise<void>;
  selectCurrentFilters: (
    name: string,
    value: AfriexPaymentProcessors | string | number | Date | undefined,
  ) => void;
  /** Returns whether the filters were applied; false when validation rejected them. */
  handleApplyFilters: () => boolean;
  selectAppliedFilters: (
    name: string,
    value: AfriexPaymentProcessors | string | number | Date | undefined,
  ) => void;
  clearFilters: () => void;
  handleOffsetChange: (newOffset: number, limit: number) => Promise<void>;
};
